import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../../assets/css/main.css";

import mcglogo from '../../assets/img/mycareergems logo final.png';

function Header() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  const toggleMobileNav = () => {
    setMobileNavOpen((prev) => !prev);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="il-header sticky-top bg-white shadow-sm">
      <div className="il-container d-flex align-items-center justify-content-between py-4 px-4">
        {/* <Link to="/" className="il-logo d-flex align-items-center text-decoration-none">
          <img
            src={mcglogo}
            alt="MyCareerGems Logo"
            className="il-logo-img"
            width={150}
            height={60}
            // style={{ height: '40px', width: 'auto' }}
          />
        </Link> */}

        <Link to="/" className="d-none d-lg-block">
          <h4 className="il-logo-text">MyCareerGems</h4>
        </Link>


        <nav className="il-nav-menu d-none d-lg-flex align-items-center">
          <ul className="il-menu-list list-unstyled d-flex mb-0">
            <li className="il-menu-item mx-3">
              <Link to="/" className={`il-nav-link ${isActive("/") ? "active" : ""}`}>
                Home
              </Link>
            </li>
            <li className="il-menu-item mx-3">
              <Link to="/about" className={`il-nav-link ${isActive("/about") ? "active" : ""}`}>
                About
              </Link>
            </li>
            <li className="il-menu-item mx-3">
              <Link to="/updates" className={`il-nav-link ${isActive("/updates") ? "active" : ""}`}>
                Updates
              </Link>
            </li>
            <li className="il-menu-item mx-3">
              <Link to="/locations" className={`il-nav-link ${isActive("/locations") ? "active" : ""}`}>
                Locations
              </Link>
            </li>
            <li className="il-menu-item mx-3">
              <Link to="/services" className={`il-nav-link ${isActive("/services") ? "active" : ""}`}>
                Services
              </Link>
            </li>
            <li className="il-menu-item mx-3">
              <Link to="/pricing" className={`il-nav-link ${isActive("/pricing") ? "active" : ""}`}>
                Pricing
              </Link>
            </li>
            {/* <li className="il-menu-item mx-3 dropdown position-relative">
              <a
                href="#dropdown"
                className="il-nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Dropdown
              </a>
              <ul className="il-dropdown-menu dropdown-menu position-absolute bg-white shadow rounded-3 p-2">
                <li>
                  <Link to="/option1" className={`il-dropdown-item ${isActive("/option1") ? "active" : ""}`}>
                    Option 1
                  </Link>
                </li>
                <li>
                  <Link to="/option2" className={`il-dropdown-item ${isActive("/option2") ? "active" : ""}`}>
                    Option 2
                  </Link>
                </li>
                <li>
                  <Link to="/option3" className={`il-dropdown-item ${isActive("/option3") ? "active" : ""}`}>
                    Option 3
                  </Link>
                </li>
              </ul>
            </li> */}
            <li className="il-menu-item mx-3">
              <Link to="/contact" className={`il-nav-link ${isActive("/contact") ? "active" : ""}`}>
                Contact
              </Link>
            </li>
          </ul>
        </nav>
        <div className="d-flex flex-column align-items-center">
          <Link to="/" className="il-logo d-flex align-items-center text-decoration-none">
            <img
              src={mcglogo}
              alt="MyCareerGems Logo"
              className="il-logo-img"
              width={70}
              height={70}
            // style={{ height: '40px', width: 'auto' }}
            />
          </Link>
          <small className="font-bold slogan" style={{ fontWeight: 'bold', fontStyle: 'italic' }}>YOUR PERFECT LAUNCHPAD</small>

        </div>
        <i
          className={`il-mobile-toggle d-lg-none bi ${mobileNavOpen ? "bi-x" : "bi-list"} fs-2`}
          onClick={toggleMobileNav}
        ></i>
      </div>
      <div className={`il-nav-menu-mobile d-lg-none ${mobileNavOpen ? "open" : ""}`}>
        <div className="il-mobile-header d-flex justify-content-between align-items-center px-4 py-3">
          <span className="il-mobile-logo">Menu</span>
          <i
            className="bi bi-x fs-3 il-mobile-close-icon"
            onClick={toggleMobileNav}
          ></i>
        </div>
        <ul className="il-mobile-menu list-unstyled mb-0">
          <li className="il-mobile-item border-bottom py-3">
            <Link to="/" className={`il-nav-link ${isActive("/") ? "active" : ""}`}>
              Home
            </Link>
          </li>
          <li className="il-mobile-item border-bottom py-3">
            <Link to="/about" className={`il-nav-link ${isActive("/about") ? "active" : ""}`}>
              About
            </Link>
          </li>
          <li className="il-mobile-item border-bottom py-3">
            <Link to="/updates" className={`il-nav-link ${isActive("/updates") ? "active" : ""}`}>
              Updates
            </Link>
          </li>
          <li className="il-mobile-item border-bottom py-3">
            <Link to="/locations" className={`il-nav-link ${isActive("/locations") ? "active" : ""}`}>
              Locations
            </Link>
          </li>
          <li className="il-mobile-item border-bottom py-3">
            <Link to="/services" className={`il-nav-link ${isActive("/services") ? "active" : ""}`}>
              Services
            </Link>
          </li>
          <li className="il-mobile-item border-bottom py-3">
            <Link to="/pricing" className={`il-nav-link ${isActive("/pricing") ? "active" : ""}`}>
              Pricing
            </Link>
          </li>
          {/* <li className="il-mobile-item border-bottom py-3">
            <Link to="/dropdown" className={`il-nav-link ${isActive("/dropdown") ? "active" : ""}`}>
              Dropdown
            </Link>
          </li> */}
          <li className="il-mobile-item py-3">
            <Link to="/contact" className={`il-nav-link ${isActive("/contact") ? "active" : ""}`}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
